<div id="generate-audio" class="m-3">
    <h1>Generar audio</h1>

    <div id="audio-destination">
        <p class="fw-bold">Destino del audio:</p>
        <label class="d-block">
            <input type="radio" name="audio-destination" value="heading" (click)="changeDestination('heading')">
            <span class="ms-1">Audio descripción de enunciado</span>
        </label>
        <label class="d-block">
            <input type="radio" name="audio-destination" value="multimedia" (click)="changeDestination('multimedia')">
            <span class="ms-1">Audio descripción de imagen</span>
        </label>
        <label class="d-block">
            <input type="radio" name="audio-destination" value="download" (click)="changeDestination('download')">
            <span class="ms-1">Descarga</span>
        </label>
    </div>

    <div id="audio-destination-course" class="mt-3" *ngIf="destination != ''">
        <label for="course-units" class="d-block" *ngIf="destination != 'download' && courseUnits">
            <p class="fw-bold">Unidad:</p>
            <select name="course-units" id="course-units" [(ngModel)]="selectedUnit" (ngModelChange)="selectUnit($event)">
                <option disabled selected value="-1">Seleccione una unidad...</option>
                <option *ngFor="let unit of courseUnits" value="{{ unit.id }}">
                    {{ unit.name }}
                </option>
            </select>
        </label>
        
        <label for="units-lessons" class="d-block" *ngIf="unitLessons && selectedUnit != -1">
            <p class="fw-bold">Lección:</p>
            <select name="unit-lessons" id="unit-lessons" [(ngModel)]="selectedLesson" (ngModelChange)="selectLesson($event)">
                <option disabled selected value="-1">Seleccione una lección...</option>
                <option *ngFor="let lesson of unitLessons" value="{{ lesson.id }}">
                    {{ lesson.name }}
                </option>
            </select>
        </label>
        
        <label for="lesson-headings" class="d-block" *ngIf="destination == 'heading' && lessonHeadings.length > 0">
            <p class="fw-bold">Enunciado:</p>
            <select name="lesson-headings" id="lesson-headings" [(ngModel)]="selectedHeading">
                <option disabled selected value="-1">Seleccione un enunciado...</option>
                <option *ngFor="let heading of lessonHeadings" [value]="heading.id">
                    {{ heading.name }}
                </option>
            </select>
        </label>

        <label for="lesson-multimedia-images" class="d-block" *ngIf="destination == 'multimedia' && lessonImages.length > 0">
            <p class="fw-bold">Imagen:</p>
            <ul id="lesson-multimedia-images">
                <li *ngFor="let image of lessonImages">
                    <label for="lesson-image-{{ image.id }}" class="d-block">
                        <input type="radio" id="lesson-image-{{ image.id }}" name="lesson-image" (click)="selectedImage = image.id">
                        <img width="200" height="200" src="{{ image.url }}" alt="{{ image.alt }}">
                    </label>
                </li>
            </ul>
        </label>
    </div>

    <div id="audio-lesson-no-multimedia" *ngIf="destination == 'multimedia' && selectedLesson != -1 && lessonImages.length == 0">
        <p>Esta lección no tiene imágenes. Por favor, seleccione otra lección.</p>
    </div>

    <div id="audio-options" *ngIf="(destination == 'heading' && selectedHeading != -1) || (destination == 'multimedia' && selectedImage != -1) || (destination == 'download')">
        <label for="text" class="d-block">
            <p class="fw-bold">Texto a procesar:</p>
            <textarea name="text" id="text" cols="30" rows="10" [(ngModel)]="text"></textarea>
        </label>

        <label for="voice" class="d-block">
            <p class="fw-bold">Voz a usar:</p>
            <select name="voice" id="voice" [(ngModel)]="voice">
                <option disabled value="null">...</option>
                <option value="Lucia">Lucia (voz femenina en español de España)</option>
                <option value="Mia">Mia (voz femenina en español de México)</option>
                <option value="Lupe">Lupe (voz femenina en español de EEUU)</option>
                <option value="Pedro">Pedro (voz masculina en español de EEUU)</option>
                <option value="Amy">Amy (voz femenina en inglés de Reino Unido)</option>
                <option value="Emma">Emma (voz femenina en inglés de Reino Unido)</option>
                <option value="Brian">Brian (voz masculina en inglés de Reino Unido)</option>
                <option value="Arthur">Arthur (voz masculina en inglés de Reino Unido)</option>
                <option value="Ivy">Ivy (voz femenina infantil en inglés de EEUU)</option>
                <option value="Joanna">Joanna (voz femenina en inglés de EEUU)</option>
                <option value="Kendra">Kendra (voz femenina en inglés de EEUU)</option>
                <option value="Kimberly">Kimberly (voz femenina en inglés de EEUU)</option>
                <option value="Salli">Salli (voz femenina en inglés de EEUU)</option>
                <option value="Joey">Joey (voz masculina en inglés de EEUU)</option>
                <option value="Justin">Justin (voz masculina infantil en inglés de EEUU)</option>
                <option value="Kevin">Kevin (voz masculina infantil en inglés de EEUU)</option>
                <option value="Matthew">Matthew (voz masculina en inglés de EEUU)</option>
            </select>
        </label>

        <div id="generate-save-audio-status" class="mt-3">
            <div id="generate-audio-loading" *ngIf="audioGenerateLoading">
                <i class="fa fa-spinner fa-spin"></i>
                <span>Generando audio, espere por favor...</span>
            </div>
            <div id="generate-audio-success" class="text-success" *ngIf="audioGenerateSuccess">
                <i class="fa fa-check"></i>
                <span>¡Audio generado exitosamente!</span>
            </div>
            <div id="generate-audio-error" class="text-danger" *ngIf="audioGenerateError">
                <i class="fa fa-times"></i>
                <span>El audio no se pudo generar correctamente.</span>
            </div>
            <div id="save-audio-loading" *ngIf="audioSaveLoading">
                <i class="fa fa-spinner fa-spin"></i>
                <span>Guardando audio, espere por favor...</span>
            </div>
            <div id="save-audio-success" class="text-success" *ngIf="audioSaveSuccess">
                <i class="fa fa-check"></i>
                <span>¡Audio guardado exitosamente!</span>
            </div>
            <div id="save-audio-error" class="text-danger" *ngIf="audioSaveError">
                <i class="fa fa-times"></i>
                <span>El audio no se ha podido guardar correctamente.</span>
            </div>
        </div>

        <div id="generate-audio-buttons" class="mt-3">
            <button class="btn btn-primary me-3" routerLink="/course/{{ courseID }}" routerLinkActive="active">
                <i class="fa fa-arrow-left"></i>
                <span>Volver</span>
            </button>

            <button class="btn btn-success me-3" (click)="generateAudio()">
                <i class="fa fa-play-circle"></i>
                <span>Generar audio</span>
            </button>

            <button *ngIf="audioGenerateSuccess" class="btn btn-success me-3" (click)="listenAudio($event)">
                <i class="fa fa-headphones"></i>
                <span>Escuchar audio</span>
            </button>

            <button *ngIf="audioGenerateSuccess" class="btn btn-success me-3" (click)="downloadAudio()">
                <i class="fa fa-file-audio"></i>
                <span>Descargar audio</span>
            </button>

            <button *ngIf="audioGenerateSuccess && destination != 'download'" class="btn btn-success me-3" (click)="saveAudio()">
                <i class="fa fa-save"></i>
                <span>Guardar audio</span>
            </button>
        </div>
    </div>
</div>